export const FILTER_TYPE = {
  REGULAR: 0,
  ORDER_STATUS: 1,
  PAYMENT_STATE: 2,
  FIAT: 3
};
